import { Button, CircularProgress, IconButton, Icons, Stack } from '@healthinal/ui';

export type FormSaveCancelActions = {
  onSave: () => void;
  onCancel: () => void;
  isDirty: boolean;
  isSaving: boolean;
  isSaveDisabled: boolean;
};

type FormSaveCancelButtonsProps = FormSaveCancelActions & {
  variant: 'text' | 'icon';
};

export function FormSaveCancelButtons({
  onSave,
  onCancel,
  isDirty,
  isSaving,
  isSaveDisabled,
  variant,
}: FormSaveCancelButtonsProps) {
  if (variant === 'text') {
    return (
      <>
        <Button color="neutral" onClick={onCancel} disabled={!isDirty || isSaving}>
          Abbrechen
        </Button>
        <Button onClick={onSave} loading={isSaving} disabled={isSaveDisabled}>
          Speichern
        </Button>
      </>
    );
  }

  return (
    <Stack direction="row" gap={0.5}>
      <IconButton
        variant="outlined"
        color="neutral"
        size="sm"
        title="Abbrechen"
        onClick={onCancel}
        disabled={!isDirty || isSaving}>
        <Icons.Close />
      </IconButton>
      <IconButton
        variant="outlined"
        color="neutral"
        size="sm"
        title="Speichern"
        onClick={onSave}
        disabled={isSaveDisabled}>
        {isSaving ? <CircularProgress size="sm" /> : <Icons.Check />}
      </IconButton>
    </Stack>
  );
}
